import React from 'react'

const PlusWmoIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16" fill="none">
    <path
      d="M13.1667 8.66671H9.16671V12.6667H7.83337V8.66671H3.83337V7.33337H7.83337V3.33337H9.16671V7.33337H13.1667V8.66671Z"
      fill="#3E3E47"
    />
  </svg>
)

export default PlusWmoIcon
